import { ApiInitializerContainer } from "./ApiInitializerContainer";

export default ApiInitializerContainer;
